<button class="main_button {{style}}" type="{{type}}" (keydown.enter)="enterPressed()" (click)="!disabled && onClick()" [ngClass] = "{'disabled' : disabled, 'loading' : loading}">
    <span class="text">{{text}}</span>
    <span class="loader"></span>
    <svg role="img" title="{{icon}}" class="icon-{{icon}}" *ngIf="icon != null">
        <use [attr.href]="'assets/images/sprite.svg#icon-' + [icon]"></use>
    </svg>
</button>
